import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import axios from "axios";

const authToken = process.env.GATSBY_AUTH_TOKEN;

const TaxonomySidebarFilter = ({ iframeIds = [], contentType }) => {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState([]);
  const [debounceVal, setDebounceVal] = useState("");

  async function searchResult() {
    const apiUrl = `https://api.catcomnet.com/taxonomy-vocabularies/${contentType}/taxonomies?search=${debounceVal}&per_page=3`;

    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    console.log(response.data?.data);
    setResult(response.data?.data || []);
    setLoading(false);
  }

  useEffect(() => {
    const refetchData = setTimeout(() => {
      setDebounceVal(search);
      setLoading(true);
    }, 400);

    return () => clearTimeout(refetchData);
  }, [search]);

  useEffect(() => {
    searchResult();
  }, [debounceVal]);

  function truncateText(str) {
    return str?.length > 30 ? str.substring(0, 30) + "..." : str;
  }

  return (
    <div className="sidebar relative">
      {/* Popular posts */}

      <form className="search__container relative">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          type="text"
          placeholder="Search here..."
        />
        {/* {!debounceVal ? (
          <button disabled={!debounceVal}>Search</button>
        ) : (
          <Link
            className="button no-underline"
            to={`/search?query=${debounceVal}`}
          >
            Search
          </Link>
        )} */}

        {debounceVal && (
          <div className="absolute z-10 top-12 left-0 w-full px-3 py-3 rounded-md shadow-lg bg-white">
            {loading && <h5>Loading ...</h5>}
            {!loading && result.length > 0 && (
              <div className="w-full py-2 space-y-2">
                {result.map((post, index) => (
                  <Link
                    to={`/${post.slug}`}
                    key={index}
                    className="flex w-full space-x-2 no-underline"
                  >
                    {post.images?.length ? (
                      <img
                        src={post.images?.[0]}
                        alt={post.title}
                        className="w-16 h-16 object-cover rounded-md aspect-square"
                      />
                    ) : (
                      post.image && (
                        <img
                          src={post.image}
                          alt={post.title}
                          className="w-16 h-16 object-cover rounded-md aspect-square"
                        />
                      )
                    )}
                    <div className="inline-block">
                      {/* <h6 className="text-xs mb-0 uppercase tracking-wide">
                        {post.tags?.[0]?.name}
                      </h6> */}
                      <h5 className="text-base font-bold tracking-[0.015em] text-black">
                        {truncateText(post.name)}
                      </h5>
                    </div>
                  </Link>
                ))}
                {/* {data?.allPost.length > 3 && (
                  <div className="pt-2">
                    <Link
                      className="button no-underline"
                      to={`/search?query=${debounceVal}`}
                    >
                      See all results
                    </Link>
                  </div>
                )} */}
              </div>
            )}
          </div>
        )}
      </form>

      <div className="popularpost__container">
        {/* <h4>Popular Blogs</h4> */}

        <div className="popularpost__list sm:space-x-5 lg:space-x-0 lg:space-y-5">
          {iframeIds.map((id) => (
            <iframe
              key={id}
              src={`https://ads.catcomnet.com/ad-spaces/${id}/embed`}
              allow="geolocation: *"
              width="200"
              height="400"
              className="rounded-xl"
            ></iframe>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TaxonomySidebarFilter;
